import { Item } from './src/Item'
export { Item }
export default Item



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/components/Item/index.ts